module.exports = __webpack_public_path__ + "img/Feature.a10aa801.png";